export const TemplateType = {
  REMINDER_SCADENZA: 'reminder_scadenza',
  WELCOME: 'welcome',
  RESET_PASSWORD: 'reset_password',
  SCADENZA_COMPLETATA: 'scadenza_completata',
  REPORT_SETTIMANALE: 'report_settimanale',
  CUSTOM: 'custom'
} as const;

export type TemplateType = typeof TemplateType[keyof typeof TemplateType];

export const TemplateTypeLabels: Record<TemplateType, string> = {
  [TemplateType.REMINDER_SCADENZA]: 'Reminder Scadenza',
  [TemplateType.WELCOME]: 'Benvenuto',
  [TemplateType.RESET_PASSWORD]: 'Reset Password',
  [TemplateType.SCADENZA_COMPLETATA]: 'Scadenza Completata',
  [TemplateType.REPORT_SETTIMANALE]: 'Report Settimanale',
  [TemplateType.CUSTOM]: 'Personalizzato'
};

export interface StoricoVersione {
  versione: number;
  oggetto: string;
  htmlBody: string;
  textBody: string;
  modificatoDa: string;
  modificatoIl: string;
}

export interface EmailTemplate {
  id: string;
  nome: string;
  tipo: TemplateType;
  oggetto: string;
  htmlBody: string;
  textBody?: string;
  descrizione?: string;
  variabiliDisponibili: string[];
  allegatiDefault: string[];
  abilitato: boolean;
  versione: number;
  isVersioneCorrente: boolean;
  storicoVersioni: StoricoVersione[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmailTemplateDto {
  nome: string;
  tipo: TemplateType;
  oggetto: string;
  htmlBody: string;
  textBody?: string;
  descrizione?: string;
  variabiliDisponibili?: string[];
  allegatiDefault?: string[];
}

export interface UpdateEmailTemplateDto {
  nome?: string;
  tipo?: TemplateType;
  oggetto?: string;
  htmlBody?: string;
  textBody?: string;
  descrizione?: string;
  variabiliDisponibili?: string[];
  allegatiDefault?: string[];
  abilitato?: boolean;
}

export interface PreviewEmailTemplateDto {
  sampleData: Record<string, unknown>;
}

export interface PreviewEmailTemplateResponse {
  oggetto: string;
  htmlBody: string;
  textBody?: string;
  variabiliUtilizzate: string[];
  variabiliMancanti?: string[];
}

export interface EmailTemplateFilters {
  search?: string;
  tipo?: TemplateType;
  abilitato?: boolean;
}
